import { StyleSheet } from "react-native";
import { FONT_SIZE } from "@common/themes";


export const styles = StyleSheet.create({
  filterListContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  filterItem: {
    width: 150,
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
  },
  filterLabel: {
    fontWeight: "500",
    fontSize: 14,
    paddingTop: 8,
  },
  applyFilterLabel: {
    fontWeight: "500",
    fontSize: 16,
    color: "#fff",
  },
});

export  const muiStyles = {
  outerContainer: { padding: 2 },
  filterButton: {
    textTransform: "none",
    color: "#6300A3",

  },
  filterIcon: { color: "#2E054E", marginRight: "4px" },
  filterText: { fontSize: 16, color: "#6300A3" },
  dropdownIcon: { color: "#2E054E" },
  filterModal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalBox: {
    width: 700,
    height: 568,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
  },
  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #eee",
    padding: 2.5,
  },
  headerTitle: {
    fontWeight: 600,
    fontSize: "20px",
  },
  bodyContainer: { display: "flex", flex: 1, minHeight: 0 },
  filterListContainer: {
    width: 156,
    borderRight: "1px solid #eee",
    overflowY: "auto",
    height: "100%",
  },
  filterItem: {
    bgcolor: "transparent",
    borderBottom: "1px solid #eee",
    paddingY: "20px",
    display: "flex",
    justifyContent: "space-between",
  },
  filterValueContainer: {
    flex: 1,
    p: 2,
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    height: "100%",
  },
  noFilterText: {
    marginTop: 16,
    marginLeft: 8,
    color: "#888",
  },
  filterLabel: {
    fontWeight: 500,
    fontSize: FONT_SIZE.s2,
    paddingTop: 8,
    color: "#555555",
  },
  filterModalActions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    paddingBottom: 4,
    paddingTop: 2,
    borderTop: "1px solid #eee",
    gap: 2,
  },
  applyButton: {
    textTransform: "none",
    color: "#6300A3",
    height: "40px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
  removeAllButton: {
    textTransform: "none",
    backgroundColor: "#CD2C391A",
    width: "100px",
    height: "40px",
    paddingX: "10px",
  },
  searchInput: {
    backgroundColor: "#F6F6F6",
    border: "1px solid #F6F6F6",
    borderRadius: 1,
    padding: 1,
    marginBottom: 2,
    "&.Mui-focused": {
      backgroundColor: "transparent",
      border: "1px solid #F6F6F6",
    },
  },
  searchIcon: {
    color: "#888",
    marginRight: 1,
  },
  cancelIcon: {
    color: "#888",
    marginLeft: 1,
  },
};